module.exports = __webpack_public_path__ + "static/media/nhl-sprites.65fb1714.png";